/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NDCDetailsTextFieldComponent } from '../NDCDetailsHeaderDetailsComponent';
import CMSUROATableComponent from './CMSUROATableComponent';

const CMSUROA = (props) => {
  const { fullScreen, setFullScreen } = { ...props };
  const [rowSelected, setRowSelected] = useState(null);
  const currentNDCDetailsSelected = useSelector(
    (state) => state.sharedState.ndc.currentNDCDetailsSelected
  );
  const generalSystemParameterDetails = useSelector(
    (state) => state?.sharedState?.ndc?.generalSystemParameter?.paramGeneralVO
  );

  useEffect(() => {
    setRowSelected(null);
  }, [currentNDCDetailsSelected]);

  return (
    <div className='row'>
      {!fullScreen && (
        <>
          {generalSystemParameterDetails?.[0]?.hideCmsUraInd !== 1 && (
            <div className='col-4'>
              <NDCDetailsTextFieldComponent
                label={'Unit Rebate Offset Amount'}
                value={
                  (rowSelected && rowSelected.unitRebateOffsetAmt) || '0.00'
                }
                required={false}
              />
            </div>
          )}
        </>
      )}

      <CMSUROATableComponent
        setRowSelected={setRowSelected}
        currentNDCDetailsSelected={currentNDCDetailsSelected}
        {...props}
      />
    </div>
  );
};

export default CMSUROA;
